import NavBar from './NavBar';
import { Outlet } from 'react-router-dom';

export default function MainLayout() {
  return (
    <div className="min-h-screen pb-[72px]" style={{ backgroundColor: '#000' }}>
      <Outlet />
      <NavBar />
    </div>
  );
}
